

module.directive('hover', function($q, $timeout) {
    return {
        scope: {loadData: '&'},
        controller: function($scope, $element) {
            var hover = this, isHovering = false, cancel;

            hover.show = false;

            this.apply = function(fn) {
                return function() {
                    $scope.$apply(fn.bind(hover));
                }
            }

            this.showContent = function() {
                isHovering = true;
                if (angular.isUndefined(hover.data)) {
                    $q.when($scope.loadData()).then(function(data) {
                        if (isHovering) {
                            hover.data = data;
                            hover.show = true;
                            $element.addClass('open');
                            // $timeout(checkOverlap);
                        }
                    });
                } else if(!scope.show) {
                    hover.show = true;
                    $timeout.cancel(cancel);
                }
            }

            this.hideContent = function() {
                isHovering = false;
                hover.show = false;
                $element.removeClass('open');

                $timeout.cancel(cancel);
                cancel = $timeout(function() {
                    if (!isHovering) {
                        delete hover.data;
                        cancel = undefined;
                    }
                }, 5000);
            }

            $element.on('mouseleave', hover.apply(hover.hideContent));
        },
    };
});

module.directive('hoverTarget', function() {
    return {
        require: '^hover',
        link: function(scope, element, attrs, hoverController) {
            element.on('mouseenter', hoverController.apply(hoverController.showContent));
        },
    };
});

module.directive('hoverContent', function() {
    return {
        transclude: true,
        scope: {template: '@'},
        require: '^hover',
        link: function(scope, element, attrs, hoverController) {
            scope.hover = hoverController;
        },
        template: [
            "<div class='dropdown' ng-if='hover.show'>",
                "<div class='dropdown-content'>",
                    "<ng-transclude></ng-transclude>",
                    "<ng-include ng-if='template' src='template'></ng-include'>",
                "</div>",
            "</div>",
        ].join(''),
    };
});

module.directive("hoverIcon", function($q, $timeout, Page) {
    return {
        restrict: 'E',
        templateUrl: 'util/widgets/hoverIcon',
        transclude: true,
        scope: {
            icon: '@',
            count: '=',
            template: '@',
            loadData: '&',
            text: '@',
        },
        link: function(scope, element, attrs) {
            var hovering = false,
                cancel;

            scope.show = false;

            function checkOverlap() {
                var dropDown = element[0].querySelector('.dropdown-content');
                element.toggleClass('right', !Page.horizontallyBoundByContent(dropDown));
            }

            scope.showContent = function() {
                hovering = true;
                if (angular.isUndefined(scope.data)) {
                    $q.when(scope.loadData()).then(function(data) {
                        if (hovering) {
                            scope.data = data;
                            scope.show = true;
                            $timeout(checkOverlap);
                        }
                    });
                } else if(!scope.show) {
                    scope.show = true;
                    $timeout.cancel(cancel);
                }
            };

            scope.hideContent = function() {
                hovering = false;
                scope.show = false;
                element.removeClass('right');

                $timeout.cancel(cancel);
                cancel = $timeout(function() {
                    if (!hovering) {
                        delete scope.data;
                        cancel = undefined;
                    }
                }, 5000);
            };
        },
    };
});
